import GtagService from 'modules/app/services/ga/GtagService';

class HeaderEvents {
  sendClick = (options) => {
    GtagService.sendClick({
      subcategory: 'HorizontalMenu',
      ...options
    });
  };
}

export default new HeaderEvents();
